const FormatReducer =  (state = [], action) => {
      return state
}

export default FormatReducer;
